var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2005 14.3917V10.6851C28.2005 8.48506 26.4005 6.68506 24.2005 6.68506H18.8672C17.8405 6.68506 16.9072 7.08506 16.2005 7.72506C15.4939 7.08506 14.5605 6.68506 13.5339 6.68506H8.20052C6.00052 6.68506 4.20052 8.48506 4.20052 10.6851V14.3917C3.38719 15.1251 2.86719 16.1784 2.86719 17.3517V25.3517H5.53385V22.6851H26.8672V25.3517H29.5339V17.3517C29.5339 16.1784 29.0139 15.1251 28.2005 14.3917ZM18.8672 9.35173H24.2005C24.9339 9.35173 25.5339 9.95173 25.5339 10.6851V13.3517H17.5339V10.6851C17.5339 9.95173 18.1339 9.35173 18.8672 9.35173ZM6.86719 10.6851C6.86719 9.95173 7.46719 9.35173 8.20052 9.35173H13.5339C14.2672 9.35173 14.8672 9.95173 14.8672 10.6851V13.3517H6.86719V10.6851ZM5.53385 20.0184V17.3517C5.53385 16.6184 6.13385 16.0184 6.86719 16.0184H25.5339C26.2672 16.0184 26.8672 16.6184 26.8672 17.3517V20.0184H5.53385Z",
    fill: "#8385DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.70ea4d87499cac9a32d1adb398c2ae84.svg";
export { ForwardRef as ReactComponent };